import { BCMSStateManagerCRUD } from "@bcm-dev/bcms-vite";
import NotificationsSettingsPage, { getDefaultPageUI } from "components/pages/NotificationsSettingsPage";

export default function CaptureNotifiLimAddEmail(props) {
    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
        .update([ "modal", "id" ], "AddContactMethodModal")
        .update([ "modal", "data" ], { workflowType: "addEmailWorkflow" })
        .submit();

    return <NotificationsSettingsPage ui={ ui } />
}